<template>
  <div>
    <!-- <div class="box-headline">
      מילה מהמילון:
    </div> -->
    <div class="box">
      <div v-if="!isAsso">
        <div class="top-part">
          <div class="save" v-if="!isSaved" @click="saveWord(true)">
            <div class="icon-wrapper">
              <inline-svg
                class="save-svg"
                :src="require('../../assets/svg/notsaved.svg').default"
              >
              </inline-svg>
            </div>
            <p>{{ $t("dictionary.box.save") }}</p>
          </div>
          <div class="save" v-if="isSaved" @click="saveWord(false)">
            <div class="icon-wrapper">
              <inline-svg
                class="save-svg"
                :src="require('../../assets/svg/saved.svg').default"
              ></inline-svg>
            </div>
            <p v-if="isSaved">{{ $t("dictionary.box.remove") }}</p>
          </div>
          <div class="assosyazia" @click="goAsso">
            <div class="icon-wrapper">
              <inline-svg
                :class="assoNum > 0 ? 'bolt-icon' : 'bolt-icon-dis'"
                :src="require('../../assets/svg/bolt.svg').default"
              ></inline-svg>
            </div>
            <p>{{ $t("dictionary.box.association") }}</p>
          </div>
          <div class="mischak" @click="goPlay">
            <div class="icon-wrapper">
              <inline-svg
                class="mischak-svg"
                :src="require('../../assets/svg/GameHalf.svg').default"
              ></inline-svg>
            </div>
            <p>{{ $t("dictionary.box.game") }}</p>
          </div>
        </div>
        <div class="translations dicWord">
          <div class="translate arbT">
            {{ word.Eng }}
          </div>
          <div class="translate heb">
            {{ word.heb }}
          </div>

          <!-- <div class="translate arb">
            {{ word.arb }}
          </div> -->
        </div>

        <div class="box-footer">
          <!-- <Choose
            :value="settings.right"
            :showOptions="showOptions.right"
            @setOption="setOption"
            @toggleOptions="toggleOptions"
            :options="optionsRight"
            side="right"
            class="choose-elemnt"
          /> -->
          <button
            v-if="!noSound"
            class="audioButton flex"
            @click="playButton"
            :disabled="!isLoadedAudio"
          >
            <img :src="speakerSvg" class="img-audio" alt="audio" />
          </button>
          <audio ref="player">
            <source :src="audioSrc" type="audio/mp3" />
          </audio>
          <!-- <Choose
            :value="settings.left"
            :showOptions="showOptions.left"
            @setOption="setOption"
            @toggleOptions="toggleOptions"
            :options="optionsLeft"
            side="left"
            class="choose-elemnt"
          /> -->
        </div>
      </div>
      <div v-if="isAsso" class="assoBox">
        <div class="arrows right-prev">
          <button class="fillBtn" @click="prevAsso">
            <inline-svg
              :class="currentAsso > 1 ? 'arrow-icon' : 'arrow-icon-dis'"
              :src="arrowIconPath.arrowIconPrevious"
            ></inline-svg>
          </button>
        </div>
        <div class="arrows left-next" @click="nextAsso">
          <button class="fillBtn">
            <inline-svg
              :class="currentAsso < assoNum ? 'arrow-icon' : 'arrow-icon-dis'"
              :src="arrowIconPath.arrowIcoNext"
            ></inline-svg>
          </button>
        </div>
        <div class="top-part-asso">
          <div class="backIcon" @click="isAsso = false">
            <inline-svg
              :src="require('../../assets/svg/back.svg').default"
            ></inline-svg>
            <p></p>
          </div>
          <!-- <div class="mischak">
          <inline-svg
            class="mischak-svg"
            :src="require('../../assets/svg/GameHalf.svg').default"
          ></inline-svg>
          <p>משחק</p>
        </div> -->
        </div>
        <div class="assoText">
          <div class="heb">
            {{ associations[currentAsso - 1] }}
          </div>
        </div>
      </div>
    </div>
    <div class="dotsDiv" v-if="isAsso" @click.prevent>
      <div
        class="dots"
        :class="{ dotHide: !(assoNum > 0), dotActive: currentAsso == 1 }"
      ></div>
      <div
        class="dots"
        :class="{ dotHide: !(assoNum > 1), dotActive: currentAsso == 2 }"
      ></div>
      <div
        class="dots"
        :class="{ dotHide: !(assoNum > 2), dotActive: currentAsso == 3 }"
      ></div>
    </div>
    <div v-if="isAsso" class="addAssoBtn" @click="dialog = true">
      {{ $t("dictionary.box.add_association") }}
    </div>
    <div class="box-headline" v-if="sentences.length">
      {{ $t("dictionary.box.example") }}
    </div>
    <div class="box" v-if="arabSen">
      <!-- <div class="arrows right-prev">
        <button>
          <inline-svg
            class="arrow-icon"
            :src="arrowIconPath.arrowIconPrevious"
          ></inline-svg>
        </button>
      </div>
      <div class="arrows left-next">
        <button>
          <inline-svg
            class="arrow-icon"
            :src="arrowIconPath.arrowIcoNext"
          ></inline-svg>
        </button>
      </div> -->
      <div class="arrows right-prev">
        <button class="fillBtn" @click="prevSen">
          <inline-svg
            :class="currentSen > 1 ? 'arrow-icon' : 'arrow-icon-dis'"
            :src="require(`../../assets/svg/arrow-right.svg`).default"
          ></inline-svg>
        </button>
      </div>
      <div class="arrows left-next" @click="nextSen">
        <button class="fillBtn">
          <inline-svg
            :class="currentSen < senNum ? 'arrow-icon' : 'arrow-icon-dis'"
            :src="require(`../../assets/svg/arrow-left.svg`).default"
          ></inline-svg>
        </button>
      </div>
      <div class="translations">
        <div class="sens">
          <div class="hebSen sentence uppercase">
            {{ sentences[currentSen - 1].eng }}
          </div>
          <div class="sentence">
            {{ sentences[currentSen - 1].heb }}
          </div>
        </div>
        <!-- <div class="translate arb sentence">
          {{ word.arb }}
        </div> -->
        <button
          class="audioButton flex"
          :class="{ audioDis: !senAudioSrc }"
          @click="playSenButton"
          :disabled="!senAudioSrc"
        >
          <img
            :src="speakerSvg"
            class="img-audio"
            :class="{ audioDis: !senAudioSrc }"
            alt="audio"
          />
        </button>
        <audio ref="senplayer">
          <source :src="senAudioSrc" type="audio/mp3" />
        </audio>
      </div>
    </div>
    <v-dialog v-model="dialog" width="500">
      <!-- <template v-slot:activator="{ on }">
        <v-btn color="red lighten-2" dark v-on="on">
          Click Me
        </v-btn>
      </template> -->

      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ $t("dictionary.box.suggest_association") }}
        </v-card-title>

        <v-card-text>
          <textarea
            id="addword"
            name="addword"
            :placeholder="placeholder"
            class="textBox"
          ></textarea>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false">
            {{ $t("dictionary.box.send") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import "./box.scss";
import Choose from "./choose.vue";
import data from "../../assets/data/data.json";
export default {
  props: {
    word: {
      type: Object,
      default: () => {}
    },
    language: {
      type: String,
      default: "heb"
    },
    savedWords: {
      type: Array,
      default: () => []
    },
    hebSen: {
      type: String,
      default: null
    },
    arabSen: {
      type: String,
      default: null
    },
    sentenceId: {
      type: String,
      default: null
    },
    sentences: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialog: false,
      isAsso: false,
      assoNum: 0,
      currentAsso: 0,
      senNum: 0,
      currentSen: 0,
      noSound: false,
      isLoadedAudio: false,
      audioSrc: "",
      senAudioSrc: "",
      senAudioId: null,
      optionsRight: [],
      optionsLeft: [],
      settings: {
        left: "",
        right: ""
      },
      showOptions: {
        right: false,
        left: false
      },
      speakerSvg: require("../../assets/svg/orange-speaker.svg").default,
      placeholder: this.$t("dictionary.box.placeholder"),
    };
  },
  mounted() {
    this.noSound = false;
    this.getAudio();
    this.getSenAudio();
    this.assoNum = this.associations.length;
    this.senNum = this.sentences.length;
  },
  created() {
    this.defineSettings();
  },
  computed: {
    isSaved() {
      return this.savedWords.includes(this.word.id);
    },
    associations() {
      let asso = [];
      if (this.word.asso1) asso.push(this.word.asso1);
      if (this.word.asso2) asso.push(this.word.asso2);
      if (this.word.asso3) asso.push(this.word.asso3);
      this.assoNum = asso.length;
      if (this.assoNum) this.currentAsso = 1;
      return asso;
    }
  },
  watch: {
    word: function() {
      this.getAudio();
      this.defineSettings();
      let asso = [];
      if (this.word.asso1) asso.push(this.word.asso1);
      if (this.word.asso2) asso.push(this.word.asso2);
      if (this.word.asso3) asso.push(this.word.asso3);
      this.assoNum = asso.length;
      if (this.assoNum) this.currentAsso = 1;
      console.log(this.assoNum);
    },
    sentenceId() {
      this.getSenAudio();
    },
    senAudioId() {
      this.getSenAudio();
    },

    sentences() {
      this.senNum = this.sentences.length;
      if (this.senNum > 0) this.currentSen = 1;
    },
    currentSen() {
      this.senAudioId = this.sentences[this.currentSen - 1].id;
    }
  },
  updated() {
    if (this.word && !this.isAsso) {
      const player = this.$refs.player;
      player.load();
    }
    if (this.sentenceId) {
      const senplayer = this.$refs.senplayer;
      senplayer.load();
    }
  },
  methods: {
    goAsso() {
      if (this.assoNum) this.isAsso = true;
    },
    nextAsso() {
      if (this.currentAsso < this.assoNum)
        this.currentAsso = this.currentAsso + 1;
    },
    prevAsso() {
      if (this.currentAsso && this.currentAsso > 1)
        this.currentAsso = this.currentAsso - 1;
    },
    nextSen() {
      if (this.currentSen < this.senNum) this.currentSen = this.currentSen + 1;
    },
    prevSen() {
      if (this.currentSen && this.currentSen > 1)
        this.currentSen = this.currentSen - 1;
    },
    goPlay() {
      this.$router.push({ path: "/game/dicword", query: this.word });
    },
    setOption({ option, side }) {
      this.settings[side] = option;
      const family = this.$store.getters.family;
      const currWord = family.find(word => {
        return (
          word.right === this.settings.right && word.left === this.settings.left
        );
      });
      if (!currWord) {
        this.settings.right = this.word.right;
        this.settings.left = this.word.left;
      }
      this.$emit("search", currWord);
    },
    toggleOptions({ side, boolean }) {
      this.showOptions[side] = boolean;
    },
    defineSettings() {
      const bodies = JSON.parse(data[this.language].bodies) || [];
      const times = JSON.parse(data[this.language].times) || [];
      const groupNames = JSON.parse(data[this.language].groupNames) || [];
      const belongs = JSON.parse(data[this.language].belongs) || [];
      switch (this.word.type) {
        case "פועל":
          this.optionsLeft = bodies;
          this.optionsRight = times;
          break;
        case "עצם":
          this.optionsRight = groupNames;
          this.optionsLeft = belongs;
          break;
        case "noun":
          this.optionsRight = groupNames;
          this.optionsLeft = belongs;
          break;

        case "מילת תואר":
          this.optionsRight = groupNames;
          this.optionsLeft = [];
          break;
        case "מילת יחס":
          this.optionsLeft = belongs;
          this.optionsRight = [];
          break;
      }
      this.settings.left = this.word.left;
      this.settings.right = this.word.right;
    },
    getAudio() {
      this.isLoadedAudio = false;
      if (!this.word) return;
      // const { id, lang = 'arb' } = this.word;
      const { id, lang = "" } = this.word;
      fetch(`${process.env.VUE_APP_API_URL}/api/sound_file/${id}/`)
        .then(async response => {
          if (response.status === 200) {
            const { sound_file } = await response.json();

            this.audioSrc = sound_file;
            this.noSound = false;
            this.isLoadedAudio = true;
          } else {
            this.noSound = true;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getSenAudio() {
      if (!this.senAudioId) return;
      // const { id, lang = 'arb' } = this.word;

      fetch(
        `${process.env.VUE_APP_API_URL}/api/sound_file/${this.senAudioId}/`
      )
        .then(async response => {
          if (response.status === 200) {
            const { sound_file } = await response.json();

            this.senAudioSrc = sound_file;
          } else {
            this.senAudioSrc = null;
          }
          // this.noSound = false;
          // this.isLoadedAudio = true;
          // } else {
          //   this.noSound = true;
          // }
        })
        .catch(err => {
          console.error(err);
        });
    },
    playButton() {
      console.log("Play");
      this.$refs.player.play();
    },
    playSenButton() {
      console.log("Play");
      this.$refs.senplayer.play();
    },
    saveWord(isSaved) {
      this.$emit("saveWord", { isSaved, word: this.word });
    }
  },

  components: {
    Choose
  }
};
</script>

<style scoped>
.textBox {
  border-style: dashed;
  width: 100%;
}

.backIcon {
  width: 35px;
}

.fillBtn {
  fill: #000000;
}

.hebSen {
  color: #000000;
  margin-top: 10px;
  direction: ltr;
}

.addAssoBtn {
  border-radius: 6px;
  width: 100%;
  font-size: 26px;
  border: 1px solid #111199;
  color: #111199;
  background-color: #c4c8ff;
  margin: 10px 0;
  padding: 6px;
  text-align: center;
}

.dots {
  border: 1px solid blue;
  border-radius: 36px;
  width: 10px;
  height: 10px;
}

.dotsDiv {
  display: flex;

  justify-content: center;
  text-align: center;
  gap: 6px;
  margin-top: 8px;
  margin-bottom: 10px;
}

.dotHide {
  display: none;
}

.dotActive {
  background-color: #555fff;
}

.assoText {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 115px;
}

.uppercase:first-letter {
  text-transform: capitalize;
}

.audioDis {
  /* background-color: gray; */
  filter: grayscale(100%);
}

.sens {
  margin-bottom: 16px;
  padding: 0 30px;
}

.dicWord {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// box.vue?5942b565